// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"GD-z","smallCardRow":"HD-z","largeCardRow":"ID-z","productSearchRow":"JD-z","curatedRow":"KD-z"};